import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  request: {
    isLoading: boolean;
    error: string | null;
  };
  list: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
  one: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  request: {
    isLoading: false,
    error: null,
  },
  list: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
  one: {
    isLoading: false,
    data: null,
    error: null,
  },
};

export const { actions: scheduleActions, reducer: scheduleReducer } = createSlice({
  name: 'Schedule',
  initialState,
  reducers: {
    //Request
    setScheduleRequestStart: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setScheduleRequestSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setScheduleRequestFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },
    setScheduleRequestDefault: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    //List
    setScheduleListRequest: (state) => {
      state.list = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setScheduleListSuccess: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setScheduleListFailure: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setScheduleListDefault: (state) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },
    //One
    setScheduleOneRequest: (state) => {
      state.one = {
        isLoading: true,
        data: null,
        error: null,
      };
    },
    setScheduleOneSuccess: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setScheduleOneFailure: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
    setScheduleOneDefault: (state) => {
      state.one = {
        isLoading: false,
        data: null,
        error: null,
      };
    },
  },
});
